import Link from 'next/link';
import { memo } from 'react';

import { Button } from '@air/primitive-button';

export type NullStateLinkProps = {
  href: string;
  children: string;
  'data-testid'?: string;
};

/** Secondary help link for a null state; the primary action uses an outline `Button` alongside it. */
export const NullStateLink = memo(({ children, href, 'data-testid': testId }: NullStateLinkProps) => (
  <Button appearance="ghost" asChild color="blue" size="medium">
    <Link data-testid={testId} href={href} rel="noopener noreferrer" target="_blank">
      {children}
      <span className="sr-only"> (opens in a new tab)</span>
    </Link>
  </Button>
));

NullStateLink.displayName = 'NullStateLink';
